export function getVehicleIdFromSearch(search = window.location.search) {
  try {
    return new URLSearchParams(search).get('vehicle_id') || '';
  } catch {
    return '';
  }
}
